async function printTempIdCard(target: HTMLElement, plan: string): Promise<void> {
  try {
    const url = `/download/card/${plan}`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Accept": "application/json",
      },
    });

    // Try to parse JSON even on non-200 responses
    let msg: any = null;
    try {
      msg = await response.json();
    } catch { /* ignore parse errors */ }

    if (response.ok && msg?.meta?.code === 200) {
      window.open(msg.response, "_blank", "noopener,noreferrer"); // Redirect to the received URL
    } else {
      const metaMsg = msg?.meta?.message;
      // Prefer server-provided message; fallback to generic based on status
      const fallback = response.status === 404 ? "404: Not Found" :
                       response.status === 401 ? "Unauthorized." :
                       response.status === 400 ? "Unexpected error." : "Error in generating the card.";
      alert(metaMsg || fallback);
    }
  } catch (error) {
    alert(error instanceof Error ? error.message : "Unexpected error occurred.");
  } finally {
    toggleSpinner(target);
  }
}

function toggleSpinner(target: HTMLElement) {
  const cssClass = "visually-hidden";
  const label = target.querySelector("span:last-child");
  const spinnerElements = target.querySelectorAll("span:not(:last-child)");

  if (label.classList.contains(cssClass)) {
    label.classList.remove(cssClass);
    spinnerElements.forEach(x => x.classList.add(cssClass));
    target.removeAttribute("disabled");
  } else {
    label.classList.add(cssClass);
    spinnerElements.forEach(x => x.classList.remove(cssClass));
    target.setAttribute("disabled", "disabled");
  }
}

function initializePrintButtons() {
  document.querySelectorAll("[wf-card-plan]").forEach(button => {
    button.addEventListener("click", event => {
      event.preventDefault();

      // use current target to ensure you get the button
      const target = event.currentTarget as HTMLElement;
      const plan = target.getAttribute("wf-card-plan");
      toggleSpinner(target);

      if (!plan) {
        toggleSpinner(target);
        return;
      }

      printTempIdCard(target, plan);
    });
  });
}

document.addEventListener('DOMContentLoaded', initializePrintButtons);
